export interface Story {
  slug: string;
  title: string;
  column: string;
  summary: string;
  cover: string;
  date: string;
  author: string;
  heat: number;
  likes: number;
  views: number;
  comments: number;
  tags: string[];
  paragraphs: string[];
}

export const STORIES: Story[] = [
  {
    slug: "kuangchang-lai-yici-gaobai",
    title: "晚自习后操场告白：全宿舍楼都在窗口起哄",
    column: "biaobai",
    summary:
      "男生提前一周布置好小灯串，抱着吉他蹲守三小时。当女主角被闺蜜团推到人群中央时，整栋宿舍楼的灯都亮了起来。",
    cover:
      "https://readdy.ai/api/search-image?query=campus%20playground%20at%20night%20with%20strand%20fairy%20lights%20and%20a%20small%20stage%2C%20warm%20crowd%20silhouettes%20cheering%2C%20romantic%20red%20and%20gold%20bokeh%2C%20festive%20candid%20photo&width=900&height=600&seq=story-conf-01&orientation=landscape",
    date: "2026-09-06",
    author: "二食堂吃瓜群众",
    heat: 9,
    likes: 1234,
    views: 32800,
    comments: 486,
    tags: ["表白现场", "操场", "社团"],
    paragraphs: [
      "那天晚上九点半，操场东边忽然亮起一片暖黄色的小灯串。有同学以为是迎新活动，走近才发现是个男生在摆位——地上用荧光棒拼了名字，音响里循环着一首很老的粤语情歌。",
      "女生是新闻社的，被闺蜜团以『拍校园夜景』的名义骗到操场。等她看清地上的字，脸一下就红了。男生抱着吉他蹲在人群中央，弹到副歌直接卡壳，憋了十几秒才红着脸喊出那句表白。",
      "整栋宿舍楼像是商量好了，窗口齐刷刷亮灯，还有人拉开嗓子起哄『在一起』。最后女生笑着接了花，男生激动得把吉他弦都拨断了。据说第二天两人把荧光棒收好，说是要留作纪念。",
    ],
  },
  {
    slug: "yi-zhang-beizi-huan-yi-sheng-yuanyi",
    title: "用一整个学期的笔记，换来一句‘我愿意’",
    column: "biaobai",
    summary:
      "男生偷偷抄了一学期专业课笔记，扉页写满一整页『喜欢你』。结课时他把笔记和花一起递到女生面前。",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20handwritten%20notebook%20with%20a%20pressed%20flower%20and%20warm%20desk%20lamp%20light%2C%20soft%20cream%20and%20coral%20tones%2C%20cozy%20study%20scene%20editorial%20photography&width=900&height=600&seq=story-conf-02&orientation=landscape",
    date: "2026-09-04",
    author: "图书馆常驻",
    heat: 8,
    likes: 2109,
    views: 41500,
    comments: 692,
    tags: ["表白现场", "图书馆", "学霸"],
    paragraphs: [
      "计算机学院有个男生，每节课都坐在同一个女生后面两排。他没有勇气搭话，就默默把女生借不到的专业笔记抄了一遍，字迹工整得像印刷体。",
      "结课那天，男生把笔记重新装订，封面扉页写满了『喜欢你』三个字，旁边压了一朵干掉的桂花。他站在教室门口等她，脸憋得通红，把笔记和花一起递了出去。",
      "据说女生翻到扉页时愣了快一分钟，最后眼眶红红地说了句『我愿意』。现在两人一起上了同一门选修，笔记也变成了两个人的。",
    ],
  },
  {
    slug: "kuanianshou-tushi-qiuxiaochang",
    title: "跨年烟火下的灯牌告白，被拍进了校园宣传片",
    column: "biaobai",
    summary:
      "跨年倒数前三分钟，男生举着一块自制灯牌穿过人群，在烟火炸开的那一刻走到喜欢的人面前。",
    cover:
      "https://readdy.ai/api/search-image?query=new%20year%20fireworks%20over%20campus%20building%20with%20a%20person%20holding%20a%20glowing%20sign%2C%20night%20sky%2C%20warm%20sparkles%20and%20cool%20dusk%2C%20cinematic%20celebration%20photography&width=900&height=600&seq=story-conf-03&orientation=landscape",
    date: "2026-09-01",
    author: "新年第一瓜",
    heat: 10,
    likes: 3510,
    views: 78900,
    comments: 1203,
    tags: ["表白现场", "跨年", "烟火"],
    paragraphs: [
      "跨年那晚学校操场办了烟火晚会，倒数前人群乱成一团。就在大家都仰头看表的时候，一个男生举着一块缠满小灯泡的硬纸板，一路『借过』穿过人群。",
      "板上写的是女生的小名加一句表白，被烟火照得清清楚楚。女生原本在跟室友拍照，回头看到灯牌当场呆住。周围的同学自发让开一条道，倒数声里夹杂着此起彼伏的起哄。",
      "这场告白被学生会的同学拍进了跨年宣传片，据说后来还上了学校官微。至于结果——烟火最亮的那刻，两人拥抱的影子被拍得特别清楚。",
    ],
  },
  {
    slug: "gezhe-yiben-shu-renshi",
    title: "图书馆靠窗的位置，我们隔着一本书认识",
    column: "lianai",
    summary:
      "同一张桌子坐了一个月，谁也没先开口。直到有一天，女生不小心把水洒在男生的笔记本上，故事才真正开始。",
    cover:
      "https://readdy.ai/api/search-image?query=campus%20library%20window%20seat%20with%20stacks%20of%20books%20and%20morning%20sunlight%2C%20warm%20cream%20and%20coral%20tones%2C%20quiet%20cozy%20study%20atmosphere%20editorial%20photography&width=900&height=600&seq=story-love-01&orientation=landscape",
    date: "2026-09-05",
    author: "三楼自习室",
    heat: 7,
    likes: 987,
    views: 23600,
    comments: 354,
    tags: ["恋爱故事", "图书馆", "相识"],
    paragraphs: [
      "图书馆三楼靠窗有个固定位置，考研党都知道那是热门座位。女生和男生都盯上了它，索性一左一右隔着桌角坐，中间摞着半人高的书，算是一道『楚河汉界』。",
      "就这样坐了一个月，两人从没说过一句话，却默契到谁先到谁帮对方占杯位。直到有天女生拧水瓶时手滑，半杯水全洒在男生摊开的笔记本上。",
      "她手忙脚乱地擦，他却不生气，反而从书包里掏出干净纸巾递过去。『这页正好写完了』，他说。后来这道书墙越摞越低，再后来，靠窗那个位置只坐得下两个人了。",
    ],
  },
  {
    slug: "shenye-caochang-disan",
    title: "深夜操场的散步，把三年暗恋熬成了告白",
    column: "lianai",
    summary:
      "他们约定每周三晚去操场散步，聊电影聊未来，唯独不谈喜欢。直到大四最后一个星期三，男生停下来，说有些话再不说就晚了。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20campus%20running%20track%20at%20dusk%20with%20two%20walking%20figures%2C%20long%20shadows%2C%20warm%20amber%20and%20mint%20tones%2C%20melancholic%20romantic%20photography&width=900&height=600&seq=story-love-02&orientation=landscape",
    date: "2026-09-03",
    author: "操场夜跑者",
    heat: 8,
    likes: 1654,
    views: 29800,
    comments: 521,
    tags: ["恋爱故事", "暗恋", "操场"],
    paragraphs: [
      "大三那年因为社团活动，男生和女生每周三晚一起负责清点器材，结束后顺路去操场走两圈。走习惯了，话题也越来越多，从专业课聊到毕业后想去哪座城市。",
      "四年里两人都没说破，谁都不愿打破这种默契。可大四下学期，男生拿到了南方一家公司的 offer，离校的日子一天天逼近。",
      "最后一个星期三晚上，走到第三圈时男生忽然停下来，转过身说：『我数过，这三年我陪你走了三百多圈操场。有些话再不说，就真的没机会了。』女生愣了几秒，笑了。那晚他们一直走到操场熄灯。",
    ],
  },
  {
    slug: "yidi-san-nian-women-haobao-xiangdu",
    title: "异地第三年，我们终于学会了把想念说出口",
    column: "lianai",
    summary:
      "一南一北两座城市，靠每天的视频和攒下来的车票撑过三年。当争吵开始变多，他们决定做点不一样的事。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20phones%20on%20video%20call%20on%20a%20campus%20desk%20at%20night%2C%20warm%20desk%20lamp%20and%20train%20ticket%20polaroid%20photos%2C%20cozy%20long%20distance%20love%20story%20photography&width=900&height=600&seq=story-love-03&orientation=landscape",
    date: "2026-08-28",
    author: "车站常客",
    heat: 9,
    likes: 2456,
    views: 53400,
    comments: 877,
    tags: ["恋爱故事", "异地恋", "毕业季"],
    paragraphs: [
      "男生在东北读研，女生在南方实习，中间隔着两千多公里。异地第三年，视频里的两个人开始为『今天为什么不回消息』『这周末能不能来看我』这类小事拌嘴。",
      "又一次冷战后，男生买了一张连夜硬座票，坐了二十小时出现在女生宿舍楼下。他把攒了半年的车票装进一个铁盒，票根背面每张都写着当天想对她说的话。",
      "他说：『我们不是不想对方，是总怕说多了显得黏人。以后想就说出来吧。』女生抱着铁盒哭得稀里哗啦。异地恋的难题没有消失，但他们学会了不把想念憋在心里。",
    ],
  },
  {
    slug: "yitiao-weihuishide-xiaoxi",
    title: "因为一条没回的消息，我们冷战了三个月",
    column: "fenshou",
    summary:
      "她发了一条分享日常的消息，对方忙实验忘了回。等她再问起，得到的回应让她彻底心凉，这段三年的感情就此画上句号。",
    cover:
      "https://readdy.ai/api/search-image?query=a%20smartphone%20screen%20showing%20left%20on%20read%20with%20a%20cup%20of%20cold%20tea%2C%20muted%20dusk%20lighting%2C%20sage%20and%20grey%20tones%2C%20quiet%20melancholy%20flat%20lay%20photography&width=900&height=600&seq=story-break-01&orientation=landscape",
    date: "2026-09-02",
    author: "谁还没冷过战",
    heat: 6,
    likes: 856,
    views: 19800,
    comments: 402,
    tags: ["分手内幕", "冷战", "沟通"],
    paragraphs: [
      "女生那天拍了一张食堂新出的甜品图发给男友，想跟他分享下午的小开心。消息发出去，像往常一样安静地躺在聊天框里。",
      "她以为他在忙，没催。可第二天刷到他在游戏里连胜，第三天看他给共同好友的朋友圈点了赞。她终于没忍住，问了一句『你是不想理我了吗』。得到的回复是淡淡的『你想多了』。",
      "从那天起两人进入漫长的冷战。三个月后，男生才在某次争吵中承认，自己那阵子状态很差，怕把坏情绪倒给她，干脆选择沉默。可那句迟来的解释，已经接不住她攒了一整季的委屈。感情死于一条没回的消息，其实是死于不肯开口。",
    ],
  },
  {
    slug: "liubai-gongli-shuzai-fenqi",
    title: "他毕业回家乡，我们输给了六百公里",
    column: "fenshou",
    summary:
      "一个是留在省城读研的女生，一个是必须回家接手生意的男生。计划了无数个‘以后’，最后都败给了那张回乡车票。",
    cover:
      "https://readdy.ai/api/search-image?query=person%20waiting%20on%20a%20railway%20platform%20with%20a%20suitcase%20at%20sunrise%2C%20empty%20tracks%20receding%2C%20warm%20gold%20and%20soft%20grey%2C%20cinematic%20farewell%20photography&width=900&height=600&seq=story-break-02&orientation=landscape",
    date: "2026-08-30",
    author: "毕业月台",
    heat: 8,
    likes: 1876,
    views: 36400,
    comments: 733,
    tags: ["分手内幕", "毕业季", "异地"],
    paragraphs: [
      "男生家里在老家有生意等着接手，女生则考上了省城的研究生。毕业前的那个春天，他们认真地聊过很多次：先异地两年、攒钱在中间城市买房、周末互相跑。",
      "可真正到了填志愿、订车票的时候，两边父母的电话、现实的工作安排，像一张越织越密的网。两人谁都没有做错什么，只是方向再也对不齐了。",
      "送站那天，女生站在月台上看着车缓缓开走，忽然明白过来——不是不爱了，是两个人的『未来』从某一刻起就长成了不同的样子。六百公里隔着的不只是距离，还有各自没法让步的人生。",
    ],
  },
  {
    slug: "pengyouquan-guannxuan-woshi-nage-bei-kuazhao",
    title: "朋友圈官宣那天，他把我从相册里删得干干净净",
    column: "fenshou",
    summary:
      "在共同好友晒出新恋情的同一周，她发现自己被悄悄移出了所有合照和分组。体面分手，成了另一种残忍。",
    cover:
      "https://readdy.ai/api/search-image?query=smartphone%20in%20hand%20with%20social%20media%20profile%20blurred%20and%20a%20half%20empty%20coffee%20cup%2C%20cool%20muted%20light%2C%20modern%20melancholy%20photography&width=900&height=600&seq=story-break-03&orientation=landscape",
    date: "2026-08-25",
    author: "吃瓜不嫌事大",
    heat: 7,
    likes: 1345,
    views: 27600,
    comments: 518,
    tags: ["分手内幕", "朋友圈", "官宣"],
    paragraphs: [
      "恋爱时男生把两人的合照设成朋友圈背景，旅行照、食堂照、雨伞下的背影，攒了满满一个相册。女生以为这段关系很稳，连分手都只是说了句『我们都需要静静』。",
      "可过了两周，女生在共同好友的动态里看到他发了新的官宣照片。她下意识点进他朋友圈，背景换了，分组也变了，曾经那些合照就像从没存在过。",
      "她没有哭闹，只是默默把手机放回口袋。朋友劝她删干净算报仇，她说：『他提前删完了，我再删一遍，也没什么意义。』有些体面的分手，其实是早已在心里练习过很多遍的告别。",
    ],
  },
  {
    slug: "gongxiang-qinglv-hao-zhengzhi-yiti",
    title: "因为共用情侣账号，恋爱第180天我们大吵一架",
    column: "jiufen",
    summary:
      "为省一个月会员费，两人共用一个视频账号。可当『观看记录』和『消息提示』开始互相干涉，甜蜜绑定变成了互相猜疑。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20phones%20sharing%20one%20streaming%20app%20profile%20with%20headphones%20and%20popcorn%2C%20bright%20green%20and%20cream%20tones%2C%20playful%20lifestyle%20photography&width=900&height=600&seq=story-q-01&orientation=landscape",
    date: "2026-08-29",
    author: "账号管理员",
    heat: 6,
    likes: 765,
    views: 17300,
    comments: 389,
    tags: ["情侣纠纷", "共享账号", "信任"],
    paragraphs: [
      "恋爱半年纪念日，男生提议共用一个视频会员账号，说是省钱又能『同步追剧』。女生起初觉得挺甜，可日子一长，麻烦接踵而至。",
      "男生深夜看的悬疑片会出现在『为你推荐』里，女生白天追的甜剧进度也常被顶掉。更烦的是账号消息提示总是『叮』一声冒出来，两个人谁看了什么，另一个猜得一清二楚。",
      "第180天，两人因为『你是不是不喜欢看我跟你说那部剧』这种话拌嘴，越说越上纲上线，最后演变成关于信任的大吵。冷静下来后他们一致决定：账号分开，感情归感情，看剧归看剧。有时候适度的距离，反而比无孔不入的绑定更舒服。",
    ],
  },
  {
    slug: "yuehui-aa-zhi-fenqi",
    title: "约会AA制的分歧，让我们的感情亮起了红灯",
    column: "jiufen",
    summary:
      "女生坚持吃饭各付各的，男生却觉得这样『太生分』。一次关于谁买单的争吵，撕开了消费观差异的口子。",
    cover:
      "https://readdy.ai/api/search-image?query=restaurant%20receipt%20and%20two%20pairs%20of%20hands%20reaching%20for%20a%20payment%20terminal%2C%20neutral%20cafe%20lighting%2C%20clean%20green%20and%20white%20palette%2C%20honest%20lifestyle%20photography&width=900&height=600&seq=story-q-02&orientation=landscape",
    date: "2026-08-22",
    author: "账单观察员",
    heat: 5,
    likes: 654,
    views: 14900,
    comments: 312,
    tags: ["情侣纠纷", "AA制", "消费观"],
    paragraphs: [
      "两人都是普通大学生，生活费不算宽裕。女生一直习惯约会AA，觉得这样谁也不欠谁，心理负担小。男生却觉得谈恋爱男生多承担是『基本礼仪』，每次抢着买单。",
      "有次在西餐厅，为了一笔几百块的账单，两人当着服务员的面拉拉扯扯。女生红着脸说了句『你能不能别让我难堪』，男生当场愣住。那顿饭吃得格外安静。",
      "回家后他们认真谈了一次，才发现分歧不在钱，而在『AA到底代不代表疏远』。最后两人约定：日常小钱轮流来，大额消费就摊开算。谈钱不伤感情，回避谈钱才伤。",
    ],
  },
  {
    slug: "dayouxi-hengliu-he-dianhua",
    title: "上分关键时刻和接电话，他选了前者",
    column: "jiufen",
    summary:
      "她身体不舒服打来电话，男生正打到游戏晋级赛的决胜局。等他打完那局回拨过去，那边已经挂了。",
    cover:
      "https://readdy.ai/api/search-image?query=gamer%20setup%20with%20controller%20and%20a%20phone%20with%20missed%20calls%20on%20desk%2C%20cool%20ambient%20rgb%20and%20warm%20lamp%2C%20casual%20campus%20room%20photography&width=900&height=600&seq=story-q-03&orientation=landscape",
    date: "2026-08-18",
    author: "峡谷旁观者",
    heat: 6,
    likes: 923,
    views: 20600,
    comments: 447,
    tags: ["情侣纠纷", "游戏", "优先级"],
    paragraphs: [
      "晚上九点，女生胃疼得厉害，打给男朋友想让他帮忙带点药。电话响的时候，男生正带着队伍打到晋级赛决胜团，眼睛盯着屏幕，犹豫了两秒还是没接。",
      "那局赢了，他心情不错，回拨过去想分享战绩，对面却传来忙音。再打，直接被挂断。他这才反应过来，赶紧出门买药跑去找人，可女生已经自己吃了药睡下。",
      "第二天两人吵了一架。男生解释那是打了三个小时才遇到的晋级关键局，女生只问了一句：『我排在你人生里第几位，是那局游戏后面吗？』那次之后，男生把她的号码设了特别提示音。游戏可以重开，有些电话错过了就补不回来了。",
    ],
  },
  {
    slug: "ta-he-wo-xiongdi-chifan",
    title: "她和我的好兄弟单独吃饭，我该装作没看见吗",
    column: "jiegao",
    summary:
      "餐厅转角撞见女友和兄弟有说有笑地吃饭，男生没有上前质问，却一整晚都在反复回放那个画面。",
    cover:
      "https://readdy.ai/api/search-image?query=two%20people%20talking%20across%20a%20cafe%20table%20seen%20through%20a%20window%20reflection%2C%20soft%20blur%2C%20muted%20warm%20tones%2C%20suspenseful%20cinematic%20photography&width=900&height=600&seq=story-tri-01&orientation=landscape",
    date: "2026-08-26",
    author: "转角遇见瓜",
    heat: 8,
    likes: 1520,
    views: 30200,
    comments: 689,
    tags: ["三角纠葛", "信任", "兄弟"],
    paragraphs: [
      "男生陪朋友去校外吃饭，路过一家小馆子的落地窗，余光瞥见靠窗坐着的两个人——一个是谈了三年的女友，另一个是他的铁哥们，两人正对着菜单笑得开怀。",
      "他第一反应是拿出手机假装回消息，没敢走进去。那顿饭他吃得心不在焉，脑海里反复回放刚才的画面，越想越不是滋味，却又怕直接质问显得小气。",
      "当晚他小心翼翼地问女友今天去哪了，对方随口说『和同学吃饭』。他憋了一肚子话，最终只应了声『哦』。这种欲言又止的猜疑，往往比真相更伤人。感情里最怕的不是误会本身，而是明明在意，却谁都不肯先把话摊开。",
    ],
  },
  {
    slug: "qianren-xinhuantongkuang-xiangke",
    title: "前任和新欢一起选了同一门课，我心态当场崩了",
    column: "jiegao",
    summary:
      "选课系统把她和前任的新欢排进了同一间教室，一学期要面对面熬过几十个课时。这种尴尬，换谁都得当场破防。",
    cover:
      "https://readdy.ai/api/search-image?query=students%20in%20a%20lecture%20hall%20sitting%20far%20apart%20with%20awkward%20body%20language%2C%20bright%20classroom%20light%2C%20cool%20green%20and%20cream%20tones%2C%20observational%20photography&width=900&height=600&seq=story-tri-02&orientation=landscape",
    date: "2026-08-20",
    author: "选课系统受害者",
    heat: 9,
    likes: 2280,
    views: 44700,
    comments: 954,
    tags: ["三角纠葛", "选课", "前任"],
    paragraphs: [
      "新学期选课，女生想选那门口碑很好的『电影鉴赏』，手速快抢到了名额。上课第一天她走进教室，正对上前任和他新女友并排坐的背影，空气仿佛凝固了几秒。",
      "那节课老师让大家做自我介绍破冰，轮到那两人时她全程低头记笔记，耳朵却红到脖子根。更要命的是这门课按小组出勤，她只能硬着头皮跟尴尬共处一学期。",
      "后来她想通了：与其躲，不如把注意力放在课程本身。期末她拿了小组最高分，还当着全班做了一次漂亮的作品分享。体面不体面，从来不是看谁先躲开，而是看谁能把日子过成自己的主场。",
    ],
  },
  {
    slug: "shixizu-de-aimei-sirenju",
    title: "实习小组里若即若离的暧昧，让四个人都很难受",
    column: "jiegao",
    summary:
      "同一个实习小组的四个人，因为一次项目协作产生了说不清道不明的暧昧氛围。本该专心做方案，却被关系搅得一团乱。",
    cover:
      "https://readdy.ai/api/search-image?query=group%20of%20college%20students%20around%20a%20meeting%20table%20with%20laptops%20and%20papers%2C%20tense%20yet%20neutral%20mood%2C%20warm%20office%20lighting%2C%20documentary%20photography&width=900&height=600&seq=story-tri-03&orientation=landscape",
    date: "2026-08-15",
    author: "会议室窗外",
    heat: 7,
    likes: 1021,
    views: 22800,
    comments: 473,
    tags: ["三角纠葛", "实习", "暧昧"],
    paragraphs: [
      "一个四人实习小组为了赶项目方案，连着两周泡在实验室。熬夜做资料、分工对接、一起点外卖，距离一拉近，某些微妙的气氛就悄悄冒了头。",
      "A觉得B开会总先看她，B却以为A对自己有意思；C夹在中间察言观色，越看越觉得哪里不对，又不敢挑明。方案讨论到一半，话题经常莫名其妙跑偏，成果进度跟着遭殃。",
      "导师约谈时点破了一句：『项目做不好，关系再热也是空转。』四个人这才如梦初醒，约法三章：工作时间只聊方案，私事下了班再谈。原来成年人的分寸感，是能把工作关系和个人边界分得清清楚楚，才不会让暧昧拖垮整组人。",
    ],
  },
];